import { MaterialCommunityIcons } from "@expo/vector-icons";
import type { ReactNode } from "react";
import { Surface, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type StreakCountChipProps = {
	type: "current" | "best";
	count: number;
	icon?: ReactNode;
};

export const StreakCountChip = ({
	type,
	count,
	icon,
}: StreakCountChipProps) => {
	const theme = useAppTheme();

	const BORDER_RADIUS = 12;
	const ICON_SIZE = 24;

	const defaultIcon =
		type === "current" ? (
			<MaterialCommunityIcons
				name="fire"
				size={ICON_SIZE}
				color={theme.colors.onSecondaryContainer}
			/>
		) : (
			<MaterialCommunityIcons
				name="star-outline"
				size={ICON_SIZE}
				color={theme.colors.onSecondaryContainer}
			/>
		);

	const displayIcon = icon ?? defaultIcon;
	const label = type === "current" ? "ACTIVE STREAK" : "BEST STREAK";

	return (
		<Surface
			elevation={0}
			style={{
				flex: 1,
				maxWidth: 180,
				borderRadius: BORDER_RADIUS,
				borderWidth: 1,
				borderColor: theme.colors.primaryContainer,
				backgroundColor: `${theme.colors.primaryContainer}29`,
				paddingVertical: 8,
				paddingLeft: 8,
				paddingRight: 12,
			}}
		>
			<Box flexDirection="row" alignItems="center" gap={8}>
				{displayIcon}
				<Box flex={1} gap={0}>
					<Text
						variant="labelSmall"
						style={{
							color: theme.colors.onSecondaryContainer,
						}}
					>
						{label}
					</Text>
					<Text
						variant="labelLarge"
						style={{
							color: theme.colors.onSecondaryContainer,
							fontWeight: "600",
						}}
					>
						{count} days
					</Text>
				</Box>
			</Box>
		</Surface>
	);
};
